import {
    findSlotsForTimeFrame,
    isSlotStartingHour
} from 'utils/findSlotsForTimeFrame';
import { BookingSlot } from 'api-types/models/Booking';
import { BookingSlotContent } from '../bookingSlotContent';

interface IProps {
    hour: number;
    startOfWeekDate: Date;
    index: number;
    slotsPerWeek: BookingSlot[];
    setSelectedSlot: (slot: BookingSlot) => void;
}

export function BookingTableCell({
    hour,
    startOfWeekDate,
    index,
    slotsPerWeek,
    setSelectedSlot
}: Readonly<IProps>) {
    const slots = findSlotsForTimeFrame(
        startOfWeekDate,
        index,
        hour,
        slotsPerWeek
    );

    // Only render slots that START in this hour
    const slotsToRender = slots.filter((slot) =>
        isSlotStartingHour(startOfWeekDate, index, hour, slot)
    );

    return (
        <td className={slotsToRender.length > 0 ? 'active' : 'empty'}>
            <div className='wrapper'>
                {slotsToRender.map((slot) => (
                    <BookingSlotContent
                        key={slot.slotId}
                        slot={slot}
                        setSelectedSlot={setSelectedSlot}
                        slotStartHour={hour}
                    />
                ))}
            </div>
        </td>
    );
}
